import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ContainerCollapsedButton, FilterButtonContainer, FilterButton as FilterButtonStyled } from './styles';
import { ChevronRight, FilterFunnel2Icon } from 'icons';
import { colors } from 'styles/colors';

interface FilterButtonProps {
  collapsed: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function FilterButton({
  collapsed,
  disabled,
  onClick,
}: Readonly<FilterButtonProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <ContainerCollapsedButton isCollapsed={collapsed}>
      <FilterButtonStyled
        onClick={onClick}
        type="button"
        variant="primary-stroke"
        aria-controls="filter-fields"
        aria-expanded={!collapsed}
        disabled={disabled}
      >
        <FilterButtonContainer>
          <FilterFunnel2Icon color={colors.icon['primary-base']} size="14" />
          <span>{t('filtros')}</span>
          <ChevronRight
            rotate={collapsed ? '90deg' : '270deg'}
            color={colors.icon['primary-base']}
            size="14"
          />
        </FilterButtonContainer>
      </FilterButtonStyled>
    </ContainerCollapsedButton>
  );
}
